import React, { useState, useRef } from "react";
import ICONS from "./IconMap";

const InputField = ({ iconName, onClickIcon, onOtpChange, ...rest }) => {
  const IconComponent = ICONS[iconName];
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);

  const handleChange = (index, event) => {
    const newOtp = [...otp];
    const value = event.target.value.replace(/\D/g, "");
    newOtp[index] = value.slice(0, 1);

    if (value.length === 1 && index < 5) {
      inputRefs.current[index + 1].focus();
    } else if (!value.length && index > 0) {
      inputRefs.current[index - 1].focus();
    }

    setOtp(newOtp);
  };

  const handlePaste = (event) => {
    const pastedValue = event.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    const newOtp = new Array(6).fill("");
    for (let i = 0; i < pastedValue.length; i++) {
      newOtp[i] = pastedValue[i];
    }
    setOtp(newOtp);
    inputRefs.current[pastedValue.length - 1].focus();
  };

  React.useEffect(() => {
    const otpValue = otp.join("");
    onOtpChange(otpValue);
  }, [otp, onOtpChange]);

  return (
    <div style={styles.inputContainer}>
      {iconName && <IconComponent style={styles.icon} onClick={onClickIcon} />}
      {otp.map((value, index) => (
        <input
          key={index}
          style={styles.input}
          type="text"
          value={value}
          onChange={(event) => handleChange(index, event)}
          maxLength={1}
          onPaste={handlePaste}
          autoComplete="off"
          ref={(el) => (inputRefs.current[index] = el)}
          {...rest}
        />
      ))}
    </div>
  );
};

export default InputField;

const styles = {
  inputContainer: {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    // justifyContent: "center"
    gap:'6px',
  },
  input: {
    flex: 1,
    padding: "10px",
    fontSize: "18px",
    fontWeight:"bold",
    borderTop:"none",
    borderRight:"none",
    borderLeft:"none",
    borderBottom:"2px solid #4A76FD",
    outline: "none",
    backgroundColor: "#fff",
    borderRadius: "4px",
    width: "20px",
    height: "20px",
    textAlign: "center",
    justifyContent:"center",
    alignItems:"center",
    // marginRight: "10px",
  },
  icon: {
    // position: "absolute",
    left: "10px",
    cursor: "pointer",
    fontSize: "24px",
    color: "#4A76FD",
  },
};